import { useState } from 'react';
import PropTypes from 'prop-types';
import ImportFileUpload from './ImportFileUpload';
import ImportFileMapper from './ImportFileMapper';
import ImportFileError from './ImportFileError';

const VIEWS = {
    FILE: 'file',
    MAPPER: 'mapper',
    ERROR: 'error',
};

const ERROR_MAPPING = 'import_requires_mapping';

export default function ImportFile(props) {
    const {
        onClose,
        onSuccess,
        onChangeProcessing,
        processing,
        texts,
        importService,
        fields,
        mapService,
        children,
        disabled,
        extraFileExtensions,
        dropText,
    } = props;
    const [view, setView] = useState(VIEWS.FILE);
    const [columns, setColumns] = useState(null);
    const [importId, setImportId] = useState(null);
    const [errorType, setErrorType] = useState(null);
    const [errorInfo, setErrorInfo] = useState(null);

    return (
        <>
            {view === VIEWS.ERROR && <ImportFileError onClose={onClose} type={errorType} info={errorInfo} />}

            {view === VIEWS.FILE && (
                <ImportFileUpload
                    onClose={onClose}
                    processing={processing}
                    onChangeProcessing={onChangeProcessing}
                    title={texts.importTitle}
                    description={texts.importDescription}
                    buttonText={texts.importButton}
                    importService={importService}
                    disabled={disabled}
                    extraFileExtensions={extraFileExtensions}
                    dropText={dropText}
                    onSubmit={({ importId, columns, error, errorInfo }) => {
                        if (!error) {
                            onSuccess();
                        } else if (error === ERROR_MAPPING) {
                            setView(VIEWS.MAPPER);
                            setColumns(columns);
                            setImportId(importId);
                        } else {
                            setErrorType(error);
                            setErrorInfo(errorInfo);
                            setView(VIEWS.ERROR);
                        }
                    }}
                >
                    {children}
                </ImportFileUpload>
            )}

            {view === VIEWS.MAPPER && (
                <ImportFileMapper
                    title={texts.mapperTitle}
                    description={texts.mapperDescription}
                    buttonText={texts.mapperButton}
                    onClose={onClose}
                    columns={columns}
                    importId={importId}
                    processing={processing}
                    onChangeProcessing={onChangeProcessing}
                    mapService={mapService}
                    fields={fields}
                    onSubmit={({ error, errorInfo }) => {
                        if (!error) {
                            onSuccess();
                        } else {
                            setErrorType(error);
                            setErrorInfo(errorInfo);
                            setView(VIEWS.ERROR);
                        }
                    }}
                />
            )}
        </>
    );
}

ImportFile.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    processing: PropTypes.bool.isRequired,
    onChangeProcessing: PropTypes.func.isRequired,
    texts: PropTypes.shape({
        importTitle: PropTypes.node.isRequired,
        importDescription: PropTypes.node.isRequired,
        importButton: PropTypes.string.isRequired,
        mapperTitle: PropTypes.node.isRequired,
        mapperDescription: PropTypes.node.isRequired,
        mapperButton: PropTypes.string.isRequired,
    }).isRequired,
    importService: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            required: PropTypes.bool,
            deduplicationColumns: PropTypes.bool,
            label: PropTypes.string,
        }),
    ).isRequired,
    mapService: PropTypes.func.isRequired,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    extraFileExtensions: PropTypes.arrayOf(PropTypes.string),
    dropText: PropTypes.string,
};
